<ng-container *ngIf="data">
	<ng-container *ngFor="let row of data.cells; index as i">
		<section
			*ngIf="data.headersY[i] && data.headersY[i].config && data.headersY[i].config.visible"
			class="table-row text-14 align-items-center"
			[ngClass]="{
				striped: isStriped,
				'group-member': data.headersY[i].attribute.isGroupMember,
				accordion: row[0]?.children?.length,
				expanded: expandedRowIndex === i,
				'border-color-black': tableOptions?.shouldShowSeparatorLineBelowParent,
				'border-color-regular': !tableOptions?.shouldShowSeparatorLineBelowParent
			}"
		>
			<!-- Parent/Category row -->
			<section class="row" [ngClass]="{ accordion: row[0]?.children?.length }" (click)="row[0]?.children?.length && toggleChildRow(i)">
				<!-- Expand icon as first column-->
				<ng-container *ngIf="tableOptions?.shouldShowExpandIconOnLeft">
					<figure class="arrow col col-1 text-align-right">
						<icon *ngIf="row[0]?.children?.length" type="chevron-down" class="expand-icon-left" [ngClass]="{ expanded: expandedRowIndex === i }"></icon>
					</figure>
				</ng-container>

				<!-- Category/Name cell -->
				<span
					*ngIf="data.headersY[i]"
					class="col text-sm-14-bold"
					[ngClass]="categoryColumnClass"
					attr.data-cy="dl-nested-table-category-{{ data.firstColumnTitle?.formattedValue }}-{{ i }}"
				>
					<icon
						*ngIf="(data?.headersY)[i]?.attribute?.iconType && !colors"
						[style.fill]="data.headersY[i].attribute.colorTheme || '#616161'"
						class="pull-left"
						[type]="data.headersY[i].attribute.iconType"
					></icon>
					<icon
						*ngIf="(data?.headersY)[i]?.attribute?.iconType && colors"
						[style.fill]="colors[i]"
						class="pull-left category-icon"
						[type]="(data?.headersY)[i]?.attribute?.iconType"
					></icon>
					<span class="icon-caption">{{ data.headersY[i].formattedValue }}</span>
					<dcr-cell-content [cell]="data.headersY[i]"></dcr-cell-content>
					<icon
						*ngIf="data.headersY[i].config && data.headersY[i].config.infoBubble"
						type="info-circle"
						class="info-circle text-14 color-primary"
						[tooltip]="infoBubble"
						[analytic-data]="{ linkName: 'tooltip_' + data.headersY[i].formattedValue }"
					>
					</icon>
					<ng-template #infoBubble> <section [innerHTML]="data.headersY[i].attribute.infoBubble"></section> </ng-template>
					<ng-container *ngFor="let cell of row">
						<p *ngIf="cell.config && cell.config.id === 'asOfDate'" class="text-12 as-of-date"><span dcrHTMLKey="LABEL_AS_OF">As of</span> {{ cell.formattedValue }}</p>
					</ng-container>
				</span>

				<ng-container *ngFor="let cell of row; index as j">
					<ng-container *ngIf="cell.config && cell.config.visible">
						<span
							*ngIf="cell.formattedValue; else notApplicable"
							class="col text-align-right"
							[ngClass]="dataColumnClass"
							attr.data-cy="dl-nested-table-cell-{{ data.firstColumnTitle?.formattedValue }}-{{ i }}-{{ j }}"
						>
							{{ cell.formattedValue }}
						</span>
					</ng-container>
				</ng-container>

				<!-- Icon column -->
				<figure *ngIf="tableOptions?.shouldShowDifferenceIcon" class="difference-icon arrow text-align-right col" [ngClass]="iconColumnClass">
					<ng-container *ngFor="let icon of tableOptions.iconParentCellsConfig">
						<icon *ngIf="icon.applicableParentCellsIndices.includes(i)" type="{{ icon.iconType }}" [ngClass]="icon.cssClasses"></icon>
					</ng-container>
				</figure>

				<!-- Expand icon as last column-->
				<ng-container *ngIf="!tableOptions?.shouldShowExpandIconOnLeft">
					<figure class="arrow text-align-right col col-1">
						<icon *ngIf="row[0]?.children?.length" type="chevron-down" class="expand-icon" [ngClass]="{ expanded: expandedRowIndex === i }"></icon>
					</figure>
				</ng-container>
			</section>

			<!-- Children rows -->
			<section
				[@slideInOut]
				*ngIf="row[0]?.children?.length && expandedRowIndex === i"
				class="row child-row"
				[ngClass]="{ 'separator-line': tableOptions?.shouldShowSeparatorLineBelowParent }"
			>
				<ng-container *ngFor="let child of data.headersY[i].children; index as j">
					<span *ngIf="tableOptions?.shouldShowExpandIconOnLeft" [ngClass]="expandIconColumnClass"></span>
					<p class="col category text-sm-14-medium" [ngClass]="categoryColumnClass">{{ child.formattedValue }}</p>
					<ng-container *ngFor="let data of row">
						<span *ngIf="data.children[j].formattedValue; else notApplicable" class="col data text-align-right" [ngClass]="dataColumnClass">
							{{ data.children[j].formattedValue }}
						</span>
					</ng-container>

					<!-- Icon icon -->
					<figure *ngIf="tableOptions?.shouldShowDifferenceIcon" class="difference-icon arrow text-align-right col" [ngClass]="iconColumnClass">
						<ng-container *ngFor="let icon of tableOptions.iconChildrenCellsConfig">
							<icon *ngIf="isCellIndexMatched(icon.applicableChildrenCellsIndices, i, j)" type="{{ icon.iconType }}" [ngClass]="icon.cssClasses"></icon>
						</ng-container>
					</figure>
				</ng-container>
			</section>
		</section>
	</ng-container>
</ng-container>

<ng-template #notApplicable>
	<span class="col text-align-right" [ngClass]="dataColumnClass"> <em class="not-applicable">n/a</em> </span>
</ng-template>
